export default __webpack_public_path__ + "images/8a804ea406c6dba80783f7d6fb1b79a9.png";